// this file is generated by update_shopify_store_data.py at 2026-01-26 20:22:30.236168
var courses = [
    {
        "course_id": "AD8DDADF-BAEB-EA11-8104-005056B10E33",
        "course_version": 6,
        "name": "Ten Steps to Successful Breastfeeding",
        "course_type": 1,
        "author_information": "Karin Cadwell and Cindy Turner-Maffei",
        "description": "Created specifically to support the implementation of the World Health Organization (WHO) and UNICEF Baby-Friendly Hospital Initiative, Ten Steps to Successful Breastfeeding is an essential course for educating staff to reach Baby-Friendly status. It's structured in 10 modules and mapped to the updated 2018 WHO/UNICEF Baby-Friendly objectives and Baby-Friendly USA Guidelines and Evaluation Criteria, Sixth Edition. This competency-driven online course will ensure that all parents and newborns establish optimal feeding habits and receive appropriate care in the first critical days of the baby's life.\r\n\r\nTen Steps to Successful Breastfeeding Online Course earns 15 Contact Hours, which can be completed at one's own pace, 24-hours a day. As a user progresses through the course, they will encounter Knowledge Checks that measure their understanding of the subject matter. After completing the course, they can print out a completion certificate that grants the earned Contact Hours.",
        "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:&nbsp;<br />\r\nIdentify and apply the Ten Steps to Successful Breastfeeding framework.",
        "course_outline_html": "Module 1: Introduction<br />\r\nModule 2: Step 1 of the 10 Steps to Successful Breastfeeding\r\n<br />\r\nModule 3: Step 2 of the 10 Steps to Successful Breastfeeding\r\n<br />\r\nModule 4: Step 3 of the 10 Steps to Successful Breastfeeding\r\n<br />\r\nModule 5: Step 4 of the 10 Steps to Successful Breastfeeding\r\n<br />\r\nModule 6: Step 5, Part 1 of the 10 Steps to Successful Breastfeeding\r\n<br />\r\nModule 7: Step 5, Part 2 of the 10 Steps to Successful Breastfeeding\r\n<br />\r\nModule 8: Step 5, Part 3 of the 10 Steps to Successful Breastfeeding\r\n<br />\r\nModule 9: Step 5, Part 4 of the 10 Steps to Successful Breastfeeding\r\n<br />\r\nModule 10: Step 6, Part 1 of the 10 Steps to Successful Breastfeeding\r\n<br />\r\nModule 11: Step 6, Part 2 of the 10 Steps to Successful Breastfeeding\r\n<br />\r\nModule 12: Step 7 of the 10 Steps to Successful Breastfeeding\r\n<br />\r\nModule 13: Step 8 of the 10 Steps to Successful Breastfeeding\r\n<br />\r\nModule 14: Step 9 of the 10 Steps to Successful Breastfeeding\r\n<br />\r\nModule 15: Step 10 of the 10 Steps to Successful Breastfeeding",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "D68607E1-C470-ED11-80F9-005056B10484",
                "course_category_name": "Parent: Jones and Bartlett",
                "is_system_course_category": null
            },
            {
                "course_category_id": "53066AA5-2C19-EB11-80D8-005056B14C8B",
                "course_category_name": "Jones & Bartlett",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pediatrics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                "course_category_name": "Registered Nurse First Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F50F7480-BDB4-E111-9404-0015171C5BB1",
                "course_category_name": "Jones and Bartlett - 10 Steps to Successful Breastfeeding",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FC15B3EC-2C19-EB11-80D8-005056B14C8B",
                "course_category_name": "Jones & Bartlett - Ten Steps to Successful Breastfeeding",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "BON/BON-CNA; LC",
            "accreditation_statement": "<p>The Healthy Children Project is an approved provider by the California Board of Registered Nursing, Provider number CEP4931.</p>\r\n<p>IBCLCs receive [CreditUnits] LCERPs from the International Board of Lactation Consultant Examiners.</p>",
            "course_level_accreditation_statement": "",
            "credit_display_name": "CE",
            "credit_units": 15.0,
            "credit_unit_display_name": "Contact hours; CEU or L-CERP"
        },
        "sub_courses": []
    }
];